
import React, { useEffect, useState } from "react";
import classes from './TopicsMenuNode.module.css';
import TopicNode from "./TopicNode";
import { useSelector } from "react-redux";
import * as PathRouter from '../../../../models/PathRoute'
import { NavLink } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const TopicsMenuNode = ({ isProfession, disableDeleteLesson, disableEditLesson, topicsData, courseName, tocName, selectSubMenu, selectMenu, setSubTopicId, myClass, addNewLesson, toCParentId, studyGroupId, defaultTopicId, refreshTopicList, topicId, updateTopicOrder, isDraggable }) => {
    const texts = useSelector(state => state.translate.texts);
    const homeUrl = useSelector((state) => state.application.homeUrl);


    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
        const { destination, draggableId } = result;
        const newTopicsData = [...topicsData];

        const draggedTopic = newTopicsData.find((t) => t.id === draggableId);

        if (draggedTopic) {
            const sourceIndex = newTopicsData.indexOf(draggedTopic);
            const destinationIndex = destination.index;
            newTopicsData.splice(sourceIndex, 1);
            newTopicsData.splice(destinationIndex, 0, draggedTopic);
            // newTopicsData.filter(topic=>topic.indexOnMap).forEach((topic, index) => {
            //     topic.indexOnMap = index + 1; // +1 to make it 1-based
            // });
            const newOrderIds = newTopicsData.map((t) => t.id);
            updateTopicOrder(newOrderIds, topicId, newTopicsData);
        }
    };
    return (
        <div className={`${classes.SubMenu} ${classes[`${myClass}Container`]}`}>
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable">
                    {(provided) => (
                        <div {...provided.droppableProps} ref={provided.innerRef}>
                            {topicsData && topicsData.map((t, index) =>
                                <>
                                    {isDraggable ?
                                        <Draggable key={t.id} draggableId={t.id} index={index}>
                                            {(provided, snapshot) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    snapshot={snapshot}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                >
                                                    <TopicNode
                                                        isDraggable={isDraggable}
                                                        isProfession={isProfession}
                                                        startOpen={index === 0}
                                                        disableEditLesson={disableEditLesson}
                                                        disableDeleteLesson={disableDeleteLesson}
                                                        key={index}
                                                        selectSubMenu={selectSubMenu}
                                                        selectMenu={selectMenu}
                                                        topicData={t}
                                                        setSubTopicCurrentID={setSubTopicId}
                                                        myClass={myClass}
                                                        addNewLesson={addNewLesson}
                                                        lessonId={t.id}
                                                        // defaultTopicId={defaultTopicId}
                                                        refreshTopicList={refreshTopicList}
                                                        courseName={courseName}
                                                        tocName={tocName}
                                                        studyGroupId={studyGroupId}
                                                    >
                                                    </TopicNode>
                                                </div>
                                            )}
                                        </Draggable>
                                        :
                                        <TopicNode
                                            isProfession={isProfession}
                                            startOpen={index === 0}
                                            disableEditLesson={disableEditLesson}
                                            disableDeleteLesson={disableDeleteLesson}
                                            key={index}
                                            selectSubMenu={selectSubMenu}
                                            selectMenu={selectMenu}
                                            topicData={t}
                                            setSubTopicCurrentID={setSubTopicId}
                                            myClass={myClass}
                                            addNewLesson={addNewLesson}
                                            lessonId={t.id}
                                            // defaultTopicId={defaultTopicId}
                                            refreshTopicList={refreshTopicList}
                                            courseName={courseName}
                                            tocName={tocName}
                                            studyGroupId={studyGroupId}
                                        >
                                        </TopicNode>
                                    }
                                </>
                            )}
                            {addNewLesson && <NavLink className={classes.NewCourseContainer} to={`${homeUrl}/${PathRouter.LESSONS}/${PathRouter.NEW}`} state={{ toCParentId: toCParentId, studyGroupId: studyGroupId, isProfession: isProfession, courseName: courseName, tocName: tocName, prevToCId: topicsData && topicsData.length > 0 ? topicsData[topicsData.length - 1].id : null }} >
                                <div className={classes.Circle}>+</div>
                                <p className={classes.NewCourseText}>{texts.addLesson}</p>
                            </NavLink>}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </div>
    )

}
export default TopicsMenuNode